import { render, staticRenderFns } from "./SampleBlockModal.vue?vue&type=template&id=7054d1df&"
import script from "./SampleBlockModal.vue?vue&type=script&lang=js&"
export * from "./SampleBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports